// removed by extract-text-webpack-plugin
module.exports = {"registration":"registration__2Apl_","top-section":"top-section__mtMFi","bottom-section":"bottom-section__3khid","enter-raffle":"enter-raffle__2EH2s","registration-placeholder":"registration-placeholder__9H0vP","sex-select-wrapper":"sex-select-wrapper__xGdA0","direct-button-link":"direct-button-link__1dZFL","promoLink":"promoLink__2ogtf","appHeadline":"appHeadline__16Agm","appBtns":"appBtns__2mnqp","qr":"qr__1nc4H"};


//////////////////
// WEBPACK FOOTER
// ./components/blocks/raffleDetail/styles/RegistrationArea.scss
// module id = juyG
// module chunks = 1